import { Action } from "@ngrx/store";

export const GET_TRANS_SUMMARY_BY_LEVEL3_LIST = '[Level3Summary] Get trans summary by level3 List';
export const GET_TRANS_SUMMARY_BY_LEVEL3_LIST_SUCCESS = '[Level3Summary] Get trans summary by level3 List Success';
export const GET_TRANS_SUMMARY_BY_LEVEL3_LIST_FAIL = '[Level3Summary] Get trans summary by level3 List Fail';
export const CLEAR_TRANS_SUMMARY_BY_LEVEL3_LIST = '[Level3Summary] Clear trans summary by level3 List';

export class GetTransSummaryByLevel3List implements Action {
    readonly type = GET_TRANS_SUMMARY_BY_LEVEL3_LIST;
    constructor(public payload: { institutionId: number } = null) { }
}

export class GetTransSummaryByLevel3ListSuccess implements Action {
    readonly type = GET_TRANS_SUMMARY_BY_LEVEL3_LIST_SUCCESS;
    constructor(public payload: any = null) { }
}

export class GetTransSummaryByLevel3ListFail implements Action {
    readonly type = GET_TRANS_SUMMARY_BY_LEVEL3_LIST_FAIL;
    constructor(public payload: any = null) { }
}

export class ClearGetTransSummaryByLevel3List implements Action {
    readonly type = CLEAR_TRANS_SUMMARY_BY_LEVEL3_LIST;
    constructor(public payload: any = null) { }
}

export type TransSummaryByLevel3Actions =
    | GetTransSummaryByLevel3List
    | GetTransSummaryByLevel3ListSuccess
    | GetTransSummaryByLevel3ListFail
    | ClearGetTransSummaryByLevel3List;